<template>
  <svg
    class="icon icon-chevron-wondering2"
    xmlns="http://www.w3.org/2000/svg"
    baseProfile="tiny"
    version="1.2"
    viewBox="0 0 32 32"
    :width="width"
    :height="width"
  >
    <title>wondering2</title>
    <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM22 8c1.105 0 2 0.895 2 2s-0.895 2-2 2-2-0.895-2-2 0.895-2 2-2zM8 10c0-1.105 0.895-2 2-2s2 0.895 2 2-0.895 2-2 2-2-0.895-2-2zM10.351 25.2l-0.703-2.399 13.656-4 0.703 2.399-13.656 4z"></path>
  </svg>
</template>

<script>
export default {
  name: 'error',
  props: {
    width: {
      type: Number,
      default: 100,
      required: false
    }
  }
}
</script>